import Cookies from "js-cookie";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const navigate = useNavigate();
  const accessToken = Cookies.get("access_token");

  useEffect(() => {
    if (!accessToken) {
      window.location.replace(
        "https://klipy.com/login?redirect=https://partner.klipy.com"
      );
    } else {
      navigate(window.location.pathname + window.location.search, {
        replace: true,
      });
    }
  }, [accessToken, navigate]);

  if (!accessToken) return null;

  return <>{children}</>;
}
